import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  /*
  * 消息推送管理
  * */
  pushMessageList: [],
  pushMessageMark: 0
}

const actions = {
  /*
  * 消息推送管理
  * */
  // 列表
  [types.GETPUSHLIST] (context, params) {
    http.fetch('/api/warehouseMessagePush/getMessagePushList', params).then(data => {
      context.commit(types.GETPUSHLIST, data)
    })
  },
  // 开启 / 关闭
  [types.PUSHUPDATESTATUS] (context, params) {
    http.fetch('/api/warehouseMessagePush/updateStatus', params).then(data => {
      context.commit(types.PUSHUPDATESTATUS, data)
    })
  }
}

const mutations = {
  /*
  * 消息推送管理
  * */
  // 列表
  [types.GETPUSHLIST] (state, data) {
    if (data.success) {
      state.pushMessageList = data.obj
    }
  },
  // 开启 / 关闭
  [types.PUSHUPDATESTATUS] (state, data) {
    if (data.success) {
      state.pushMessageMark = 1
      vue.$message({
        showClose: true,
        message: '操作成功',
        type: 'success'
      })
    }
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/pushMessage/index.js